import styles from './BgPurpleBlur.module.scss'


const BgPurpleBlur: React.FC = () => {
    return (
    <div className={styles.container}></div>
    )
}
export default BgPurpleBlur